<template lang="html">
	<div class="dispatch-view">
		<h2>Bestellübersicht</h2>
		<item-list :value="categories" />
		<div class="row">
			<div class="col text-right">
				<div class="total-row">
					Gesamtpreis: <span class="total">{{ total | euro }}</span>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<div 
					v-if="generalBusinessTerms" 
					class="general-business-terms" 
					v-html="generalBusinessTerms"/>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<div class="form-check">
					<label class="form-check-label">
						<input 
							type="checkbox" 
							v-model="accepted" 
							class="form-check-input">
						Hiermit akzeptiere ich die geltenden AGB
					</label>
				</div>
			</div>
		</div>
		<br>
		<div class="text-right">
			<div class="buttons has-addons is-right">
				<button 
					class="button is-secondary" 
					@click="$emit('previous')">Zurück</button>
				<button 
					class="button is-primary" 
					:disabled="!accepted" 
					@click="order">
					Zahlungspflichtig buchen
				</button>
			</div>
		</div>
		<div 
			v-if="freeTextFieldFrontend" 
			class="free-text-field" 
			v-html="freeTextFieldFrontend"/>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import ItemList from '../components/ItemList.vue'

export default {
	name: 'DispatchView',
	components: {
		ItemList
	},
	data() {
		return {
			accepted: false
		}
	},
	methods: {
		order() {
			this.$store.dispatch('order/order').then(() => {
				this.$emit('success')
			})
		}
	},
	computed: {
		...mapState('order', ['pickUpBranch', 'total']),
		categories() {
			return this.$store.state.order.positions
		},
		generalBusinessTerms() {
			return this.pickUpBranch.generalBusinessTerms || ''
		},
		freeTextFieldFrontend() {
			return this.pickUpBranch.freeTextFieldFrontend || ''
		}
	}
}
</script>

<style lang="css" scoped>
.dispatch-view .total-row{
	border-bottom: 2px solid #000;
	padding-bottom: 25px;
	margin-bottom: 25px;
}
.dispatch-view .total{
	font-weight: bold;
	font-size: 1.3em;
}
.dispatch-view svg {
	max-width: 75px;
	width: 100%;
	border-radius: 100%;
}
.general-business-terms {
	border-radius: 8px;
	padding: 20px;
	background-color: #ccc;
	max-height: 300px;
	overflow-y: auto;
	margin-bottom: 0.5em;
}
.free-text-field {
	margin-top: 0.5em;
}
</style>
